import { IbarService } from "~/services/IbarService";
import { defineStore } from "pinia";

// In-memory (per page load) dedup of the in-flight request. NOT persisted across
// loads on purpose: the Ibar is auth-state dependent (see DIF-1479 Phase 2 decision).
let inFlight: Promise<any> | null = null;

export const useIbarStore = defineStore("ibar", {
  state: () => ({
    ibar: null as any
  }),
  getters: {},
  actions: {
    // Starts (or reuses) the Ibar fetch and stores the result reactively.
    // Safe to call early (e.g. right after config in the boot plugin) so the request
    // overlaps other independent boot work (the router middleware's journey calls).
    // Deduped: concurrent/subsequent callers within the same page load reuse the result.
    load(baseUrl: string): Promise<any> {
      if (this.ibar) {
        return Promise.resolve(this.ibar);
      }
      if (inFlight) {
        return inFlight;
      }
      inFlight = IbarService.getIbarConfig(baseUrl)
        .then((response) => {
          // Only cache a real config. getIbarConfig returns [] on fetch/parse failure;
          // leaving `ibar` null keeps the navbar placeholder up (instead of mounting an
          // empty Ibar) and lets a later load() retry the request this page load. (DIF-1479)
          const failed = !response || (Array.isArray(response) && response.length === 0);
          if (!failed) {
            this.ibar = response;
          }
          return response;
        })
        .finally(() => {
          inFlight = null;
        });
      return inFlight;
    }
  }
});
